import { render, staticRenderFns } from "./147.vue?vue&type=template&id=a6c20244&scoped=true&"
import script from "./147.vue?vue&type=script&lang=js&"
export * from "./147.vue?vue&type=script&lang=js&"
import style0 from "./147.vue?vue&type=style&index=0&id=a6c20244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c20244",
  null
  
)

export default component.exports